import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M16 6L6 2v24l10 4V6zm3 20h7V2H6v23m6-7v-2" fill="none" />
  </Icon>
);
